/**
 * Generated by orval v6.19.1 🍺
 * Do not edit manually.
 * BBO Accounting Location Api
 * Accounting Location API defining how to get and modify Accounting Locations

REST APIs for Back Office stock count service. This service is specifically designed for stock functionality- stock count. Feature services are.<ul><li>Get Stock Count Type List</li></ul>

REST APIs for Back Office Forex Management Service. This service is specifically designed for forex functionality- forex counting, variance declaration, forex details, and etc. Feature services are.<ul><li>Branch Forex Overview</li><li>Fetch the Forex currencies</li></ul>

Provide Task Status and Uncompleted Task History
 * OpenAPI spec version: 0.1.0
 */
import { useMutation } from '@tanstack/react-query';
import type { MutationFunction, UseMutationOptions } from '@tanstack/react-query';

import type {
  BboDeclarationBadRequestResponse,
  BboDeclarationFailureResponseResponse,
  CreateBpTpResponseResponse,
  ForbiddenResponse,
  MonthlyStatement,
  UnauthorizedResponse,
} from '../model';
import { customInstance } from '../mutator/customInstance';
import type { ErrorType } from '../mutator/customInstance';

/**
 * @summary Create a new TP
 */
export const createTp = () => {
  return customInstance<CreateBpTpResponseResponse>({
    url: `/bm-declaration-service/v1/tp`,
    method: 'post',
  });
};

export const getCreateTpMutationOptions = <
  TError = ErrorType<
    | BboDeclarationBadRequestResponse
    | UnauthorizedResponse
    | ForbiddenResponse
    | BboDeclarationFailureResponseResponse
  >,
  TVariables = void,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<Awaited<ReturnType<typeof createTp>>, TError, TVariables, TContext>;
}): UseMutationOptions<Awaited<ReturnType<typeof createTp>>, TError, TVariables, TContext> => {
  const { mutation: mutationOptions } = options ?? {};

  const mutationFn: MutationFunction<Awaited<ReturnType<typeof createTp>>, TVariables> = () => {
    return createTp();
  };

  return { mutationFn, ...mutationOptions };
};

export type CreateTpMutationResult = NonNullable<Awaited<ReturnType<typeof createTp>>>;

export type CreateTpMutationError = ErrorType<
  | BboDeclarationBadRequestResponse
  | UnauthorizedResponse
  | ForbiddenResponse
  | BboDeclarationFailureResponseResponse
>;

/**
 * @summary Create a new TP
 */
export const useCreateTp = <
  TError = ErrorType<
    | BboDeclarationBadRequestResponse
    | UnauthorizedResponse
    | ForbiddenResponse
    | BboDeclarationFailureResponseResponse
  >,
  TVariables = void,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<Awaited<ReturnType<typeof createTp>>, TError, TVariables, TContext>;
}) => {
  const mutationOptions = getCreateTpMutationOptions(options);

  return useMutation(mutationOptions);
};
/**
 * @summary Create a new TP with Monthly Balance Statement
 */
export const createTpWithMBStatement = (monthlyStatement: MonthlyStatement) => {
  return customInstance<CreateBpTpResponseResponse>({
    url: `/bm-declaration-service/v2/tp`,
    method: 'post',
    headers: { 'Content-Type': 'application/json' },
    data: monthlyStatement,
  });
};

export const getCreateTpWithMBStatementMutationOptions = <
  TError = ErrorType<
    | BboDeclarationBadRequestResponse
    | UnauthorizedResponse
    | ForbiddenResponse
    | BboDeclarationFailureResponseResponse
  >,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof createTpWithMBStatement>>,
    TError,
    { data: MonthlyStatement },
    TContext
  >;
}): UseMutationOptions<
  Awaited<ReturnType<typeof createTpWithMBStatement>>,
  TError,
  { data: MonthlyStatement },
  TContext
> => {
  const { mutation: mutationOptions } = options ?? {};

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof createTpWithMBStatement>>,
    { data: MonthlyStatement }
  > = (props) => {
    const { data } = props ?? {};

    return createTpWithMBStatement(data);
  };

  return { mutationFn, ...mutationOptions };
};

export type CreateTpWithMBStatementMutationResult = NonNullable<
  Awaited<ReturnType<typeof createTpWithMBStatement>>
>;
export type CreateTpWithMBStatementMutationBody = MonthlyStatement;
export type CreateTpWithMBStatementMutationError = ErrorType<
  | BboDeclarationBadRequestResponse
  | UnauthorizedResponse
  | ForbiddenResponse
  | BboDeclarationFailureResponseResponse
>;

/**
 * @summary Create a new TP with Monthly Balance Statement
 */
export const useCreateTpWithMBStatement = <
  TError = ErrorType<
    | BboDeclarationBadRequestResponse
    | UnauthorizedResponse
    | ForbiddenResponse
    | BboDeclarationFailureResponseResponse
  >,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof createTpWithMBStatement>>,
    TError,
    { data: MonthlyStatement },
    TContext
  >;
}) => {
  const mutationOptions = getCreateTpWithMBStatementMutationOptions(options);

  return useMutation(mutationOptions);
};
